import React from 'react';
import { observer } from 'mobx-react-lite';

import { doChipStore } from '../../store/doChipStore';

import { RectangleTableTop } from './top';
import { RectangleTableBottom } from './bottom';

import { REC_BET_DATA_MODEL_MAP } from '../../enums/tableNumbers';
import { useRouletteDoBetValidation } from '../../hooks/useRouletteDoBetValidation';
import { useChip } from '../../hooks/useChip';
import { winningAmountStore } from '../../store/winningAmountStore';
import { toJS } from 'mobx';

const RectangleTable = observer(({ selectedData, handleMouseMove = () => {}, handleMouseLeave = () => {} }) => {
  const { selectedChip } = doChipStore;
  const { handleDoBetWithValid } = useRouletteDoBetValidation();
  const { handleGetColumnChip, memoAllChipsTypes } = useChip();
  const { winNumber } = winningAmountStore;

  const handleDoChip = (e) => {
    const valueType = e.target.getAttribute('data');
    const model = REC_BET_DATA_MODEL_MAP[valueType];
    if (model) {
      const nextChipModel = {
        [model.type]: selectedChip,
        chipType: model.type,
      };
      if (selectedChip) {
        handleDoBetWithValid(nextChipModel);
      }
    }
  };

  return (
    <div
      className='main-game-cont-inner'
      onClick={handleDoChip}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className='main-game-cont-table'>
        <RectangleTableTop
          selectedData={selectedData}
          memoAllChipsTypes={memoAllChipsTypes}
          handleGetColumnChip={handleGetColumnChip}
          winNumber={winNumber}
        />
        <RectangleTableBottom
          selectedData={selectedData}
          allChipsTypes={memoAllChipsTypes}
          handleGetColumnChip={handleGetColumnChip}
        />
      </div>
    </div>
  );
});

export default RectangleTable;
